// FILE: src/components/ui/FormField.tsx
import React from 'react';
import { Label } from './Label'; // Assuming Label is in the same directory

interface FormFieldProps {
  label: string;
  icon?: React.ElementType;
  children: React.ReactNode;
  required?: boolean;
  htmlFor?: string; // To link label and input
  error?: string;
}

export const FormField = ({
  label,
  icon: Icon,
  children,
  required = false,
  htmlFor,
  error,
}: FormFieldProps) => {
  return (
    <div className="space-y-1.5">
      <Label htmlFor={htmlFor}>
        <div className="inline-flex items-center">
          {Icon && <Icon className="mr-2 h-4 w-4 text-slate-500" />}
          <div>{label}</div>
          {required && <div className="text-red-500 ml-1">*</div>}
        </div>
      </Label>
      {children}
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};
